export const FUNCTION_SYMBOL = '^^fn^^'
export const REGEXP_SYMBOL = '^^re^^'
export const EFFECT_SYMBOL = '^^ef^^'
export const ATOM_SYMBOL = '^^at^^'
